<template>
    <div class="odd-labels" v-if="ou">
        <div class=" sp">
            {{ ou.sp }}
        </div>
        <div class="" v-if="odd" v-for="odd in sortByKey(ou.odd, 'order')">
            <Selection :selectedOdds="selectedOdds" :odd.sync="odd" :match="match" :market="ou"></Selection>
        </div>
    </div>
</template>

<script>
    import betSlip from '@/mixins/betSlip'
    import Selection from "./selection";

    export default {
        name: 'underOverOdds',
        components: {Selection},
        mixins: [betSlip],
        props: {
            market: {
                type: Number,
                default: 8
            },
            markets: {
                type: Array,
                default: function () {
                    return [-2966, 10414, 8, 47, 19, -2979, -2965, -280, 8, 203, 257, 2396, 5500, 4478, 5489, 8694, 8690, 6546, 8694,
                        6546, 12011, 8810, 8774, 8662, 8761, 9321, 9783, 6559, 6575, 8790, 8791, 8805, 386, 9098, 1919]
                }
            },
            odds: {},
            match: {},
            selectedOdds: {},
        },
        data() {
            return {
                ouDefault: {"id":"7287167","name":"","disabled":false,"closed":false,"sp":" ","hcp":"","market":4477,"markets":[17,1],"column":2,"layout":3,"order":7,"odd":{"1":{"id":14751718,"oddType":4477,"outcome":"1","odd":"1.85","sp":"0.00","live":true,"active":false,"order":1,"change":0,"r":"Waiting","resultId":1},"2":{"id":14751717,"oddType":4477,"outcome":"2","odd":"1.85","sp":"0.00","live":true,"active":false,"order":2,"change":0,"r":"Waiting","resultId":1}}},
                ou: {"id":"7287167","name":"","disabled":false,"closed":false,"sp":" ","hcp":"","market":4477,"markets":[17,1],"column":2,"layout":3,"order":7,"odd":{"1":{"id":14751718,"oddType":4477,"outcome":"1","odd":"1.85","sp":"0.00","live":true,"active":false,"order":1,"change":0,"r":"Waiting","resultId":1},"2":{"id":14751717,"oddType":4477,"outcome":"2","odd":"1.85","sp":"0.00","live":true,"active":false,"order":2,"change":0,"r":"Waiting","resultId":1}}},
                t: this.$root.t,
                virtualOdds: []
            }
        },
        watch: {
            odds: {
                handler() {
                    this.virtualOdds = Object.values(this.odds);
                    this.checkSpecialValue();
                },
                deep: true
            }
        },
        beforeDestroy() {
            //this.$bus.$off('addBet');
        },
        mounted() {

            if(this.odds){
                this.virtualOdds = Object.values(this.odds);
            }


            this.fetchSelectedBets();
            this.checkSpecialValue();

        },
        methods: {
            checkSpecialValue() {

                this.ou = this.ouDefault;

                var ag = 0;
                Object.keys(this.virtualOdds).forEach((key) => {
                    var sp = parseFloat(this.virtualOdds [key].sp);
                    if (this.markets.indexOf(this.virtualOdds [key].market) !== -1 && sp % 1 !== 0 && sp !== 'null') {
                        Object.values(this.virtualOdds[key].odd).forEach((v) => {
                            var oddn = parseFloat(v.odd);
                            ag = (oddn + ag);
                        });
                        if (ag <= 4.20)
                            this.ou = this.virtualOdds [key];
                        ag = 0;
                    }
                });
            },
            fetchSelectedBets() {

            },
        }
    }
</script>

<style scoped>
    .odd-labels {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .odd-labels div {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        flex: 1;
        font-weight: 500;
        font-size: 11px
    }

    .sp {
        background: none !important;
        color: #000;
        font-weight: lighter;
        font-size: 11px;
    }

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/underOverOdds.vue